import { AppSelectBox } from 'components';
import SelectBoxV2 from 'components/Inputs/SelectBoxV2';
import useCategory from 'hooks/API/GET/useCategory';
import { Fragment, forwardRef } from 'react';

function PodcastCategoryDropdown(
  {
    options = [],
    value,
    handleChange,
    labelClass,
    version,
    isLoading = false,
    isError = false,
    fieldErrors = {},
    defaultLook = true,
    onKeyDown,
    onFocus,
    tabIndex,
    ...otherProps
  },
  ref
) {
  const mappedOptions = options.map((o) => ({
    value: o.value,
    label: o.label,
  }));
  const handleKeyDown = (e) => {
    if (onKeyDown) {
      onKeyDown(e);
    }
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      const selectElement = e.target;
      if (selectElement && selectElement.click) {
        selectElement.click();
      }
    }
  };

  if (version === 'v2') {
    const selectedOption = mappedOptions.find((o) => o.value === value) ?? null;

    return (
      <SelectBoxV2
        labelProps={{ label: 'Podcast Genre *', className: labelClass }}
        fieldErrors={fieldErrors}
        selectProps={{
          isLoading,
          options: mappedOptions,
          value: selectedOption,
          getOptionLabel: (opt) => opt.label,
          getOptionValue: (opt) => opt.value,
          onChange: (opt) => {
            handleChange({ target: { value: opt.value } }, opt);
          },
          onKeyDown: handleKeyDown,
          onFocus: (e) => {
            if (onFocus) {
              onFocus(e);
            }
          },
          tabIndex,
          menuIsOpen: undefined,
          ...otherProps,
        }}
      />
    );
  }

  // Plain select version
  return (
    <AppSelectBox
      className="podcast-category-select"
      labelProps={{ label: 'Podcast Category', className: labelClass }}
      selectProps={{
        value,
        onChange: (event) => {
          const sel = event.target.value;
          const opt = options.find((o) => o._id === sel);
          handleChange(event, opt ? { ...opt, _id: sel } : null);
        },
        onKeyDown: handleKeyDown,
        onFocus: (e) => {
          if (onFocus) {
            onFocus(e);
          }
        },
        tabIndex,
        ...otherProps,
      }}
      fieldErrors={fieldErrors}
      options={mappedOptions}
      defaultLook={defaultLook}
    >
      {isLoading ? (
        <option disabled value="">
          Loading...
        </option>
      ) : isError ? (
        <option disabled value="">
          Failed to load list
        </option>
      ) : (
        <Fragment>
          <option value="">Choose</option>
          {mappedOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Fragment>
      )}
    </AppSelectBox>
  );
}

PodcastCategoryDropdown.defaultProps = {
  handleChange: () => {},
};

export default PodcastCategoryDropdown;
